import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import ProductCreateEditForm from './Components/ProductCreateEditForm';
import ProductApi from './ProductApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: ProductCreateEditForm,
                getCreate: ProductApi.create,
                defaults: { priority: 10 },
                successMessage: "Product Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}